/**
 * @fileoverview Shared mock adapter for the notifications feature.
 * @description The one axios-mock-adapter instance for every notifications endpoint that has no
 * real backend yet, created once and gated by VITE_ENABLE_MOCK_API — see
 * features/auth/mocks/auth-mock-adapter.ts for why every endpoint in this feature must register
 * against this single shared instance instead of constructing its own, and for why
 * `onNoMatch: 'passthrough'` is required here too so this feature's adapter doesn't swallow the
 * other features' mocked requests once it becomes the active one.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import MockAdapter from 'axios-mock-adapter'

import { appConfig } from '@/config/app-config'
import { httpClient } from '@/shared/api/http-client'

export const notificationsMockAdapter = appConfig.enableMockApi
  ? new MockAdapter(httpClient, { delayResponse: 700, onNoMatch: 'passthrough' })
  : null
